import { useEffect, useRef, useState } from "react";
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  checkUser,
  sendOtpCode,
  verifyOtpCode,
} from "live-slices/auth/register/thunk";
import { debounce } from "lodash";
import "./Common.scss";
import {
  Col,
  Form,
  FormFeedback,
  Input,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import secondCalImg from "../../assets/images/step1.png";
import CLoseImg from "../../assets/images/svg/x-circle.svg";
// import "../../../assets/scss/pages/_onBoarding.scss";
import phone from "../../assets/images/phone.svg";
import { createSelector } from "reselect";
// import { getPartners } from "live-slices/thunk";
import axios from "axios";
import { getBusinessBySellerId } from "helpers/backend_helper";
import { useNavigate } from "react-router-dom";
import ErrorModal from "./ErrorModal";

const EditPhoneNumberModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  tabIndex,
}: any) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [isButtonEnabled, setButtonEnabled] = useState(false);
  const firstInputRef = useRef<HTMLInputElement>(null);
  const firstEmailInputRef = useRef<HTMLInputElement>(null);
  const [otpValues, setOtpValues] = useState(Array(6).fill(""));
  const [otpError, setOtpError] = useState<string>("");
  const [smsVerificationId, setVerificationId] = useState<string | null>(null);
  const [otpNumberId, setOtpNumberId] = useState<string | null>(null);
  const [isVerified, setIsVerified] = useState(false);
  const dispatch = useDispatch<any>();
  const [isPhoneSendCodeDisabled, setIsPhoneSendCodeDisabled] = useState(false);
  const [phoneTimer, setPhoneTimer] = useState(0);
  const [canPhoneSendCode, setCanPhoneSendCode] = useState(true);
  const [hasSentCode, setHasSentCode] = useState(false);
  const [apiValidated, setApiValidated] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });


  // const selectPartner = createSelector(
  //   (state: any) => state.Partner,
  //   (partner) => partner?.partner
  // );
  // const partnerDet = useSelector(selectPartner);

  // useEffect(() => { }, [partnerDet]);

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const seller = useSelector(selectuserProfile);

  useEffect(() => {
  }, [seller]);


  useEffect(() => {
    let phoneCountdown: any;
    if (phoneTimer > 0) {
      phoneCountdown = setInterval(() => {
        setPhoneTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setIsPhoneSendCodeDisabled(false);
      setCanPhoneSendCode(true); // Allow resend after countdown ends
    }
    return () => clearInterval(phoneCountdown);
  }, [phoneTimer]);

  useEffect(() => {
    if (!show) {
      setOtpValues(Array(6).fill(""));
      setOtpError("");
      setVerificationId(null);
      setOtpNumberId(null);
      setIsVerified(false);
      setIsPhoneSendCodeDisabled(false);
      setPhoneTimer(0);
      setCanPhoneSendCode(true);
      setHasSentCode(false);
      setApiValidated(false);
      validation.resetForm();
    }
  }, [show]);


  const handlePhoneSendCodeClick = () => {
    if (canPhoneSendCode) {
      handleNumberSendCode();
      setIsPhoneSendCodeDisabled(true);
      setPhoneTimer(60); // Reset timer to 60 seconds
      setHasSentCode(true); // Mark that the code has been sent
      setOtpValues(Array(6).fill("")); // Reset OTP fields
      if (firstInputRef.current) firstInputRef.current.focus(); // Refocus the first input field
    }
  };

  const navigate = useNavigate();

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: seller?.phoneNumber || "",
      newPhoneNumber: "",
      _id: seller?._id
    },
    validationSchema: Yup.object({
      newPhoneNumber: Yup.string()
        .required("Please enter your phone number.")
        .matches(
          /^(?:\+92|0)\d{10}$/,
          "Phone number should start with 0 followed by 10 digits"
        ),
    }),
    onSubmit: async (values) => {
      if (apiValidated) {
        toast.error("This number already used", { autoClose: 1000 });
        return;
      }
      try {
        let obj: any = {
          phoneNumber: values.newPhoneNumber,
          smsVerificationId: smsVerificationId,
          newSmsVerificationId: smsNewVerificationId,
        };
        try {
          const response = await axios.put(`api/v1/auth/phoneNumber`, obj);
          if (response) {
            toast.success("Updated Succesfully", { autoClose: 1000 });
            onCloseClick();
            navigate("/my-account-setting");
            window.scrollTo({ top: 0, behavior: "smooth" });
            dispatch(getBusinessBySellerId(seller?._id));
          }
        } catch (err: any) {
        } finally {
        }
      } catch (error: any) {
      } finally {
      }
    },
  });

  const isPhoneNumberValid =
    validation.values.phoneNumber &&
    validation.values.phoneNumber.length >= 11 &&
    validation.values.phoneNumber.length <= 13;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      validation.handleChange(e);
      setButtonEnabled(value.length === 11);
    }
  };

  const handleNumberSendCode = async () => {
    if (
      validation.values.phoneNumber &&
      validation.values.phoneNumber.length >= 11 &&
      validation.values.phoneNumber?.length <= 13
    ) {
      try {
        const result = await dispatch(
          sendOtpCode({
            type: "sms",
            phoneNumber: validation.values.phoneNumber,
            email: "",
            isVOTP: false
          })
        );
        if (sendOtpCode.fulfilled.match(result)) {
          const responseData = result.payload; // Access the payload of the fulfilled action
          setOtpNumberId(responseData._id); // Set _id to state
          console.log("OTP ID:", responseData._id);
          toast.success("Code Sent SuccessFully!", { autoClose: 1000 });
        } else {
          console.error("Error sending OTP:", result.payload);
          toast.error("Error sending OTP", { autoClose: 1000 });
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
      }
    }
  };

  const getInputElement = (index: any): HTMLInputElement => {
    return document.getElementById(
      "digit" + index + "-input"
    ) as HTMLInputElement;
  };

  const handleKeyPressOTP = async (e: any, index: any) => {
    try {
      if (otpError) setOtpError("");
      const input = getInputElement(index);
      const value = input.value;
      if (value.length === 1 && index < 6 && e.key !== "Backspace") {
        getInputElement(index + 1)?.focus();
      }
      if (e.key === "Backspace" && index > 1 && value.length === 0) {
        getInputElement(index - 1)?.focus(); // Focus the previous input
      }

      if (value.length === 1 && index === 6) {
        input.blur(); // Remove focus from the last field
        const otpCode = Array.from({ length: 6 })
          .map((_, idx) => getInputElement(idx + 1).value)
          .join("");
        const idToVerify = otpNumberId;

        const response = await dispatch(
          verifyOtpCode({ code: otpCode, id: idToVerify })
        ).unwrap();
        setVerificationId(response.verificationId);
        console.log(response.verificationId);
        if (response.verificationId) {
          setIsVerified(true);
        } else {
          setIsVerified(false);
          setShowModal({ isVisible: true, color: false });
          setErrorMessage(`Invalid Code!`);
          setTimeout(() => {
            setShowModal({ isVisible: false, color: false });
          }, 1000);
        }
      }
    } catch (error) {
      setIsVerified(false);
      console.error("OTP Verification Error: ", error);
      setOtpError(
        "An error occurred during OTP verification. Please try again."
      );
    }
  };

  const validatePhoneNumber = async (phoneNumber: any) => {
    const fullPhoneNumber = `${phoneNumber}`;

    try {
      const result = await dispatch(
        checkUser({ username: fullPhoneNumber })
      ).unwrap();

      if (result?.isUserExist) {
        setShowModal({ isVisible: true, color: false });
        setErrorMessage(`This number already used`);
        setTimeout(() => {
          setShowModal({ isVisible: false, color: false });
        }, 1500);
        validation.setFieldError("phoneNumber", "This number already used");
        setApiValidated(false);
      } else {
        setApiValidated(true);
      }
    } catch (error) {
      console.error("Error during phone number validation:", error);
      validation.setFieldError(
        "phoneNumber",
        "Unable to validate phone number. Please try again later."
      );
      setLoader(false);
    }
  };

  const debounceValidatePhoneNumber = useCallback(
    debounce((phoneNumber: string) => {
      if (phoneNumber.length >= 9) {
        validatePhoneNumber(phoneNumber);
      }
    }, 300),
    []
  );

  const canPhoneSendCodeValidation =
    validation.values.phoneNumber &&
    isPhoneNumberValid &&
    !validation.errors.phoneNumber;

  const handlePhoneNumberChange = (e: any) => {
    const phoneNumber = e.target.value;
    validation.setFieldValue("phoneNumber", phoneNumber); // Update formik state
    setApiValidated(false); // Reset validation
    debounceValidatePhoneNumber(phoneNumber); // Trigger debounce
  };

  // New Phone Number //

  const [apiNewValidated, setApiNewValidated] = useState(false);
  const [newOtpError, setNewOtpError] = useState<string>("");
  const [otpNewNumberId, setOtpNewNumberId] = useState<string | null>(null);
  const [isNewVerified, setIsNewVerified] = useState(false);
  const [smsNewVerificationId, setNewVerificationId] = useState<string | null>(
    null
  );
  const [newOtpNumberId, setNewOtpNumberId] = useState<string | null>(null);
  const [isNewPhoneValidToSendCode, setIsNewPhoneValidToSendCode] = useState(false);
  const [newPhoneTimer, setNewPhoneTimer] = useState(0);
  const [isNewPhoneSendCodeDisabled, setIsNewPhoneSendCodeDisabled] =
    useState(false);
  const [canNewPhoneSendCode, setCanNewPhoneSendCode] = useState(true);
  const [hasSentNewCode, setHasSentNewCode] = useState(false);
  const [otpNewValues, setOtpNewValues] = useState(Array(6).fill(""));
  const firstNewInputRef = useRef<HTMLInputElement>(null);

  const handleNewPhoneNumberChange = (e: any) => {
    let phoneNumber = e.target.value;
    if (phoneNumber.startsWith("92")) {
      phoneNumber = "03" + phoneNumber.slice(3);
    }
    validation.setFieldValue("newPhoneNumber", phoneNumber);
    setApiNewValidated(false);
    debounceValidateNewPhoneNumber(phoneNumber);
  };


  const debounceValidateNewPhoneNumber = useCallback(
    debounce((phoneNumber: string) => {
      if (phoneNumber.length >= 9) {
        validateNewPhoneNumber(phoneNumber);
      }
    }, 300),
    []
  );

  const validateNewPhoneNumber = async (phoneNumber: any) => {
    const fullPhoneNumber = `${phoneNumber}`;

    try {
      setLoader(true);
      const result = await dispatch(checkUser({ username: fullPhoneNumber })).unwrap();

      if (result?.isUserExist) {
        setShowModal({ isVisible: true, color: false });
        setErrorMessage(`This number already used`);
        setTimeout(() => {
          setShowModal({ isVisible: false, color: false });
        }, 1500);
        validation.setFieldError("phoneNumber", "This number is already used");
        setApiNewValidated(false);
        setIsNewPhoneValidToSendCode(false)
      } else {
        setApiNewValidated(true);
        setIsNewPhoneValidToSendCode(true);
      }
    } catch (error) {
      console.error("Error during phone number validation:", error);
      validation.setFieldError(
        "phoneNumber",
        "Unable to validate phone number. Please try again later."
      );
      setApiNewValidated(false);
    } finally {
      setLoader(false);
    }
  };

  const handleNewKeyPressOTP = async (e: any, index: any) => {
    try {
      if (newOtpError) setNewOtpError("");
      const input = getInputNewElement(index);
      const value = input.value;
      if (value.length === 1 && index < 6 && e.key !== "Backspace") {
        getInputNewElement(index + 1)?.focus();
      }
      if (e.key === "Backspace" && index > 1 && value.length === 0) {
        getInputNewElement(index - 1)?.focus(); // Focus the previous input
      }

      if (value.length === 1 && index === 6) {
        input.blur(); // Remove focus from the last field
        const otpCode = Array.from({ length: 6 })
          .map((_, idx) => getInputNewElement(idx + 1).value)
          .join("");
        const idToVerify = newOtpNumberId;

        const response = await dispatch(
          verifyOtpCode({ code: otpCode, id: idToVerify })
        ).unwrap();
        setNewVerificationId(response.verificationId);
        console.log(response.verificationId);
        if (response.verificationId) {
          setIsNewVerified(true);
        } else {
          setIsNewVerified(false);
          setShowModal({ isVisible: true, color: false });
          setErrorMessage(`Invalid Code!`);
          setTimeout(() => {
            setShowModal({ isVisible: false, color: false });
          }, 1000);
        }
      }
    } catch (error) {
      setIsNewVerified(false);
      console.error("OTP Verification Error: ", error);
      setNewOtpError(
        "An error occurred during OTP verification. Please try again."
      );
    }
  };

  const getInputNewElement = (index: any): HTMLInputElement => {
    return document.getElementById(
      "digitTwo" + index + "-input"
    ) as HTMLInputElement;
  };

  const handleNewNumberSendCode = async () => {
    if (
      validation.values.newPhoneNumber &&
      validation.values.newPhoneNumber.length >= 11 &&
      validation.values.newPhoneNumber?.length <= 13
    ) {
      try {
        const result = await dispatch(
          sendOtpCode({
            type: "sms",
            phoneNumber: validation.values.newPhoneNumber,
            email: "",
            isVOTP: false
          })
        );
        if (sendOtpCode.fulfilled.match(result)) {
          const responseData = result.payload; // Access the payload of the fulfilled action
          setNewOtpNumberId(responseData._id); // Set _id to state
          console.log("OTP ID:", responseData._id);
          toast.success("Code Sent SuccessFully!", { autoClose: 1000 });
        } else {
          console.error("Error sending OTP:", result.payload);
          toast.error("Error sending OTP", { autoClose: 1000 });
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
      }
    }
  };

  const handleNewInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      validation.handleChange(e);
      setButtonEnabled(value.length === 11);
    }
  };

  const isNewPhoneNumberValid =
    validation.values.newPhoneNumber &&
    validation.values.newPhoneNumber.length >= 11 &&
    validation.values.newPhoneNumber.length <= 13;

  useEffect(() => {
    let phoneCountdown: any;
    if (newPhoneTimer > 0) {
      phoneCountdown = setInterval(() => {
        setNewPhoneTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setIsNewPhoneSendCodeDisabled(false);
      setCanNewPhoneSendCode(true); // Allow resend after countdown ends
    }
    return () => clearInterval(phoneCountdown);
  }, [newPhoneTimer]);

  const handleNewPhoneSendCodeClick = () => {
    if (canNewPhoneSendCode) {
      handleNewNumberSendCode();
      setIsNewPhoneSendCodeDisabled(true);
      setNewPhoneTimer(60);
      setHasSentNewCode(true);
      setOtpNewValues(Array(6).fill(""));
      if (firstNewInputRef.current) firstNewInputRef.current.focus();
    }
  };

  useEffect(() => {
    if (isVerified) {
      setPhoneTimer(0);
    }
  }, [isVerified]);

  useEffect(() => {
    if (isNewVerified) {
      setNewPhoneTimer(0);
    }
  }, [isNewVerified]);

  const canNewPhoneSendCodeValidation =
    validation.values.newPhoneNumber &&
    isNewPhoneNumberValid &&
    !validation.errors.newPhoneNumber;

  return (
    <>
      {/* <ToastContainer /> */}
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <Modal isOpen={show} centered={true} className="EditModal">
        <ModalBody className="modal-bodyEdit p-0">
          {/* <img
            data-testing-id="closeIcon"
            onClick={onCloseClick}
            className="closeIconModal"  
            src={CLoseImg}
            alt=""
          /> */}
          <div className="MainDv w-100">
            <div className="contentDv" style={{ padding: "15px" }}>
              <div className="mb-2">
                <h2 className="mainHeading mb-3">Edit Phone Number</h2>
              </div>
              <Form onSubmit={validation.handleSubmit}>
                <div className="formContainer mb-3 position-relative">
                  <label className="form-label" htmlFor="phone-input">
                    <span className="text-danger me-1">*</span> Phone Number
                  </label>
                  <Input
                    name="phoneNumber"
                    className="form-control leftPad"
                    placeholder="0300 000 0000"
                    data-testing-Id="phoneNumInput_signUp"
                    type="text"
                    readOnly
                    disabled
                    onChange={handlePhoneNumberChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phoneNumber || ""}
                    invalid={
                      validation.touched.phoneNumber &&
                        validation.errors.phoneNumber
                        ? true
                        : false
                    }
                  />
                  {validation.touched.phoneNumber &&
                    validation.errors.phoneNumber ? (
                    <FormFeedback type="invalid" className="positoleft">
                      {validation.errors.phoneNumber}
                    </FormFeedback>
                  ) : null}
                  <button
                    className={`btn btn-link position-absolute end-0 sendCode text-muted shadow-none sendCodeBtn ${phoneTimer > 0 || isPhoneSendCodeDisabled || !canPhoneSendCodeValidation || isVerified
                      ? "cursor-not-allowed"
                      : ""
                      }`}
                    type="button"
                    id="sendCode-phone"
                    data-testing-Id="sendCode_phone"
                    onClick={(e) => {
                      if (
                        phoneTimer > 0 ||
                        isPhoneSendCodeDisabled ||
                        !canPhoneSendCodeValidation
                        ||
                        isVerified
                      ) {
                        e.preventDefault();
                      } else {
                        handlePhoneSendCodeClick();
                      }
                    }}
                    aria-disabled={
                      phoneTimer > 0 ||
                      isPhoneSendCodeDisabled ||
                      !canPhoneSendCodeValidation
                      ||
                      isVerified
                    }
                  >
                    {phoneTimer > 0
                      ? `${phoneTimer}s`
                      : hasSentCode
                        ? "Resend Code"
                        : "Send Code"}
                  </button>

                  <img src={phone} className="lefticonInfoDv" alt="" />
                </div>
                <Row className="mb-4">
                  <div className="resLoginDiv">
                    <p className="mb-1 fs-6">Verify Code</p>
                  </div>
                  <Col md={9}>
                    <div className="d-flex justify-content-between mt-2">
                      {Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} style={{ padding: "0px" }}>
                          <label
                            htmlFor={`digit${index + 1}-input`}
                            className="visually-hidden"
                          >
                            Digit {index + 1}
                          </label>
                          <input
                            ref={index === 0 ? firstInputRef : null}
                            type="text"
                            style={{
                              border: "2px solid #E0ECFA",
                              width: "42px",
                              height: "39px",
                              borderRadius: "10px",
                              minHeight: "39px",
                            }}
                            className="form-control form-control-lg  text-center otpInput  p-0 "
                            maxLength={1}
                            data-testing-id={`otpCodeInput_otpVerification${index}`}
                            id={`digit${index + 1}-input`}
                            value={otpValues[index]}
                            onKeyUp={(e) => handleKeyPressOTP(e, index + 1)}
                            onChange={(e) => {
                              const newOtpValues = [...otpValues];
                              newOtpValues[index] = e.target.value;
                              setOtpValues(newOtpValues);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </Col>
                  <Col md={3} className="d-flex" style={{justifyContent: "left"}}>
                    <div className="d-flex">
                      {isVerified ? (
                        <p className="beforeVerify after">
                          {" "}
                          <i className="bx bx-check fs-4 me-1"></i> Verified{" "}
                        </p>
                      ) : (
                        <p className="beforeVerify" style={{ alignItems: "center", background: "#0877ff", borderRadius: "5px", color: "#fff", display: "flex", fontWeight: "600", height: "39px", justifyContent: "center", margin: "0px", width: "103px", marginTop: "0.5rem" }}>Verify Code</p>
                      )}
                    </div>
                  </Col>
                </Row>
                {isVerified === true && (
                  <>
                    <div className="formContainer mb-3 position-relative">
                      <label className="form-label" htmlFor="phone-input">
                        <span className="text-danger me-1">*</span> Phone Number
                      </label>
                      <Input
                        name="newPhoneNumber"
                        className="form-control leftPad"
                        placeholder="0300 000 00000"
                        data-testing-Id="phoneNumInput_signUp"
                        type="number"
                        onChange={handleNewPhoneNumberChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.newPhoneNumber || ""}
                        invalid={
                          validation.touched.newPhoneNumber &&
                            validation.errors.newPhoneNumber
                            ? true
                            : false
                        }
                      />
                      {validation.touched.newPhoneNumber &&
                        validation.errors.newPhoneNumber ? (
                        <FormFeedback type="invalid" className="positoleft">
                          {validation.errors.newPhoneNumber}
                        </FormFeedback>
                      ) : null}
                      <button
                        className={`btn btn-link position-absolute end-0 sendCode text-muted shadow-none sendCodeBtn ${newPhoneTimer > 0 || isNewPhoneSendCodeDisabled || !canNewPhoneSendCodeValidation || isNewVerified || !isNewPhoneValidToSendCode
                          ? "cursor-not-allowed"
                          : ""
                          }`}
                        type="button"
                        id="sendCode-phone"
                        data-testing-Id="sendCode_phone"
                        onClick={(e) => {
                          if (
                            newPhoneTimer > 0 ||
                            isNewPhoneSendCodeDisabled ||
                            !canNewPhoneSendCodeValidation ||
                            !isNewPhoneValidToSendCode ||
                            isNewVerified
                          ) {
                            e.preventDefault();
                          } else {
                            handleNewPhoneSendCodeClick();
                          }
                        }}
                        aria-disabled={
                          newPhoneTimer > 0 ||
                          isNewPhoneSendCodeDisabled ||
                          !canNewPhoneSendCodeValidation ||
                          isNewVerified
                        }
                      >
                        {newPhoneTimer > 0
                          ? `${newPhoneTimer}s`
                          : hasSentNewCode
                            ? "Resend Code"
                            : "Send Code"}
                      </button>

                      <img src={phone} className="lefticonInfoDv" alt="" />
                    </div>
                    <div className="resLoginDiv">
                      <p className="mb-1 fs-6">Verify Code</p>
                    </div>
                    <Row className="mb-4">
                      <Col md={9}>
                        <div className="d-flex justify-content-between">
                          {Array.from({ length: 6 }).map((_, index) => (
                            <div key={index} style={{ padding: "0px" }}>
                              <label
                                htmlFor={`digitTwo${index + 1}-input`}
                                className="visually-hidden"
                              >
                                Digit {index + 1}
                              </label>
                              <input
                                ref={index === 0 ? firstNewInputRef : null}
                                type="text"
                                style={{
                                  border: "2px solid #E0ECFA",
                                  width: "42px",
                                  height: "39px",
                                  borderRadius: "10px",
                                  minHeight: "39px",
                                }}
                                className="form-control form-control-lg  text-center otpInput  p-0 "
                                maxLength={1}
                                data-testing-id={`otpCodeInput_otpVerification${index}`}
                                id={`digitTwo${index + 1}-input`}
                                value={otpNewValues[index]}
                                onKeyUp={(e) =>
                                  handleNewKeyPressOTP(e, index + 1)
                                }
                                onChange={(e) => {
                                  const newOtpValues = [...otpNewValues];
                                  newOtpValues[index] = e.target.value;
                                  setOtpNewValues(newOtpValues);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </Col>
                      <Col md={3} className="d-flex align-items-center justify-content-end p-0">
                        <div className="d-flex">
                          {isNewVerified ? (
                            <p className="beforeVerify after">
                              {" "}
                              <i className="bx bx-check fs-4 me-1"></i> Verified{" "}
                            </p>
                          ) : (
                            <p className="beforeVerify">Verify Code</p>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className={`btn w-sm btn-secondary updateBtn`}
                    data-testing-id="deleteButton_DeleteModal"
                    disabled={!isVerified || !isNewVerified}
                  >
                    Update
                  </button>

                  <span
                    className={`btn w-sm btn-danger updateBtn`}
                    data-testing-id="closeButton_CloseModal"
                    onClick={onCloseClick}
                  >
                    Close
                  </span>
                </div>
              </Form>
            </div>
            {/* <div className="imgDv">
              <img src={secondCalImg} alt="" />
            </div> */}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

EditPhoneNumberModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  tabIndex: PropTypes.any,
};

export default EditPhoneNumberModal;
